/**
 * App — корневой компонент cabinet-app.
 *
 * Маршруты:
 * - /invite/:token — приём приглашения (public)
 * - /login — вход для зарегистрированных (public)
 * - /payment/return — возврат после оплаты ЮKassa (public)
 * - / — дашборд (требует сессию)
 * - /students/:id/topup — оплата (требует сессию)
 * - /students/:id/history — история (требует сессию)
 *
 * basename="/cabinet" задан в index.js, поэтому здесь маршруты без префикса.
 */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';

import { ParentSessionProvider, useParentSession } from './context/ParentSessionContext';
import InvitePage from './pages/InvitePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PaymentPage from './pages/PaymentPage';
import PaymentReturnPage from './pages/PaymentReturnPage';
import HistoryPage from './pages/HistoryPage';
import CompetitionRegisterPage from './pages/CompetitionRegisterPage';
import ChangePasswordRequiredPage from './pages/ChangePasswordRequiredPage';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useParentSession();
  if (loading) {
    return (
      <Center style={{ minHeight: '100vh' }}>
        <Loader color="brand-purple" />
      </Center>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  // Принудительная смена пароля после сброса администратором
  if (user.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }
  return children;
};

const AppRoutes = () => (
  <Routes>
    {/* Public */}
    <Route path="/invite/:token" element={<InvitePage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/payment/return" element={<PaymentReturnPage />} />

    {/* Forced password change (компонент сам решает, кого пускать) */}
    <Route path="/change-password" element={<ChangePasswordRequiredPage />} />

    {/* Protected */}
    <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
    <Route path="/students/:id/topup" element={<ProtectedRoute><PaymentPage /></ProtectedRoute>} />
    <Route path="/students/:id/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
    <Route path="/competitions/:id" element={<ProtectedRoute><CompetitionRegisterPage /></ProtectedRoute>} />

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

const App = () => (
  <ParentSessionProvider>
    <AppRoutes />
  </ParentSessionProvider>
);

export default App;
